module.exports = __webpack_public_path__ + "static/media/bg3.cad86fc5.png";